var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecuritySystemsHigh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 94,
    viewBox: "0 0 108 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.7189 56.5007L79.8744 60.7605L79.2022 54.7357L90.7189 56.5007Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7659_16575",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 108,
    height: 78
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 83.5V6.5H107.5V83.5H0.5Z",
    fill: "#E8EBEF",
    stroke: "#3C9103"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7659_16575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.186 102.372C78.5893 102.372 98.372 82.5893 98.372 58.186C98.372 33.7827 78.5893 14 54.186 14C29.7827 14 10 33.7827 10 58.186C10 82.5893 29.7827 102.372 54.186 102.372Z",
    stroke: "#E8EBEF",
    strokeWidth: 6.16549,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.03 10.28"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7659_16575",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 103,
    height: 78
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 6H0V84H36.5L103 52V6Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7659_16575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.372 58.186C98.372 82.5893 78.5893 102.372 54.186 102.372C29.7828 102.372 10 82.5893 10 58.186C10 33.7828 29.7828 14 54.186 14C78.5893 14 98.372 33.7828 98.372 58.186Z",
    stroke: "#3C9103",
    strokeWidth: 6.16549,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.03 10.28"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8479 58.5001C79.8479 44.5009 68.4993 33.1523 54.5001 33.1523C40.5009 33.1523 29.1523 44.5009 29.1523 58.5001C29.1523 72.4993 40.5009 83.8479 54.5001 83.8479C68.4993 83.8479 79.8479 72.4993 79.8479 58.5001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8479 58.3478C79.8479 44.3486 68.4993 33 54.5001 33C40.5009 33 29.1523 44.3486 29.1523 58.3478C29.1523 72.347 40.5009 83.6956 54.5001 83.6956C68.4993 83.6956 79.8479 72.347 79.8479 58.3478Z",
    stroke: "#333333",
    strokeWidth: 2.30435
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7659_16575",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 47,
    width: 23,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7143 47H43V69.7143H65.7143V47Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7659_16575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7143 47H43V69.7143H65.7143V47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7696 51.9132L43.6134 51.374C43.4519 51.3335 43.2776 51.3784 43.1552 51.4934C43.0327 51.609 42.9774 51.7789 43.0085 51.9438L44.4898 59.8442C44.5209 60.0101 44.6345 60.1483 44.791 60.2115C44.8502 60.2352 44.9129 60.2471 44.9752 60.2471C45.0764 60.2471 45.1771 60.216 45.262 60.1552L47.0648 58.8675L45.7696 51.9132Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.008 49.0178C63.887 48.3695 63.5216 47.8071 62.9775 47.4338C62.4339 47.061 61.7762 46.9213 61.1294 47.0427L46.8641 49.6992C46.7353 49.7229 46.6212 49.797 46.5476 49.9051C46.4736 50.0133 46.4454 50.1461 46.4691 50.275L48.2768 59.9836C48.301 60.1124 48.375 60.2265 48.4832 60.3006C48.5656 60.3574 48.6634 60.387 48.7621 60.387C48.7923 60.387 48.8224 60.3845 48.8525 60.3786L65.0587 57.3606C65.3268 57.3108 65.5036 57.053 65.4542 56.7849L64.008 49.0178ZM51.5746 53.8124C51.0384 53.9121 50.5229 53.5586 50.4232 53.0223C50.3234 52.4861 50.677 51.9706 51.2132 51.8709C51.7494 51.7711 52.2649 52.1247 52.3646 52.6609C52.4649 53.1966 52.1108 53.7121 51.5746 53.8124Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2202 62.7146C64.9471 62.7146 64.7264 62.9358 64.7264 63.2083V65.6772H60.4746C59.7473 65.6772 59.1331 65.1568 59.0126 64.4339L58.2591 60.2003C58.2112 59.9322 57.9559 59.7524 57.6868 59.8008C57.4182 59.8487 57.2395 60.105 57.2869 60.3736L58.0394 64.6018C58.2384 65.7972 59.2629 66.6648 60.4746 66.6648H64.7264V68.6399C64.7264 68.9124 64.9471 69.1336 65.2202 69.1336C65.4932 69.1336 65.7139 68.9124 65.7139 68.6399V63.2083C65.7139 62.9358 65.4932 62.7146 65.2202 62.7146Z",
    fill: "#333333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecuritySystemsHigh);
export default __webpack_public_path__ + "static/media/icon-security-systems-high.a8cfca9038f7d3cefb2a839f1c5b5a5d.svg";
export { ForwardRef as ReactComponent };